"use client";

import { GeneralError } from "@/lib/errors/GeneralError";
import ErrorPage from "./error";

export default function NotFound() {
  const err = new GeneralError("- Not Found", false, "404");

  return ErrorPage({ error: err });
}
